// Generated by npm run content:catalog. Edit product page compositions and slides.
import type { ComponentType } from "react";
import type { DocumentPageProps } from "../shared/content/types";
import { HomeDocumentPage } from '../products/website/pages/home/HomeDocumentPage';
import { ProductDocumentPage } from '../products/website/pages/product/ProductDocumentPage';
import { ProductCompanionDocumentPage } from '../products/companion/pages/product-companion/ProductCompanionDocumentPage';
import { ProductExperienceDocumentPage } from '../products/experience/pages/product-experience/ProductExperienceDocumentPage';
import { ProductIntelligenceDocumentPage } from '../products/intelligence/pages/product-intelligence/ProductIntelligenceDocumentPage';
import { ProductWorkflowsDocumentPage } from '../products/workflows/pages/product-workflows/ProductWorkflowsDocumentPage';
import { ProductOrganizationsDocumentPage } from '../products/organizations/pages/product-organizations/ProductOrganizationsDocumentPage';
import { HowItWorksDocumentPage } from '../products/website/pages/how-it-works/HowItWorksDocumentPage';
import { HowItWorksClarityDocumentPage } from '../products/clarity/pages/how-it-works-clarity/HowItWorksClarityDocumentPage';
import { HowItWorksCapabilityDocumentPage } from '../products/capability/pages/how-it-works-capability/HowItWorksCapabilityDocumentPage';
import { HowItWorksConsistencyDocumentPage } from '../products/consistency/pages/how-it-works-consistency/HowItWorksConsistencyDocumentPage';
import { HowItWorksGrowthDocumentPage } from '../products/progress/pages/how-it-works-growth/HowItWorksGrowthDocumentPage';
import { HowItWorksRhythmDocumentPage } from '../products/rhythm/pages/how-it-works-rhythm/HowItWorksRhythmDocumentPage';
import { WhoItsForDocumentPage } from '../products/website/pages/who-its-for/WhoItsForDocumentPage';
import { WhoItsForIndividualsDocumentPage } from '../products/website/pages/who-its-for-individuals/WhoItsForIndividualsDocumentPage';
import { WhoItsForProfessionalsDocumentPage } from '../products/website/pages/who-its-for-professionals/WhoItsForProfessionalsDocumentPage';
import { WhoItsForCreatorsDocumentPage } from '../products/website/pages/who-its-for-creators/WhoItsForCreatorsDocumentPage';
import { WhoItsForFoundersDocumentPage } from '../products/website/pages/who-its-for-founders/WhoItsForFoundersDocumentPage';
import { WhoItsForTeamsDocumentPage } from '../products/website/pages/who-its-for-teams/WhoItsForTeamsDocumentPage';
import { WhoItsForSmesDocumentPage } from '../products/website/pages/who-its-for-smes/WhoItsForSmesDocumentPage';
import { WhoItsForEnterprisesDocumentPage } from '../products/website/pages/who-its-for-enterprises/WhoItsForEnterprisesDocumentPage';
import { WhoItsForInstitutionsDocumentPage } from '../products/website/pages/who-its-for-institutions/WhoItsForInstitutionsDocumentPage';
import { EnterpriseDocumentPage } from '../products/organizations/pages/enterprise/EnterpriseDocumentPage';
import { SecurityDocumentPage } from '../products/website/pages/security/SecurityDocumentPage';
import { ResponsibleAiDocumentPage } from '../products/website/pages/responsible-ai/ResponsibleAiDocumentPage';
import { TrustPrivacyDocumentPage } from '../products/governance/pages/trust-privacy/TrustPrivacyDocumentPage';
import { TrustGovernanceDocumentPage } from '../products/governance/pages/trust-governance/TrustGovernanceDocumentPage';
import { PricingDocumentPage } from '../products/website/pages/pricing/PricingDocumentPage';
import { ExpertsDocumentPage } from '../products/experts/pages/experts/ExpertsDocumentPage';
import { EnterpriseContactDocumentPage } from '../products/organizations/pages/enterprise-contact/EnterpriseContactDocumentPage';
import { DemoDocumentPage } from '../products/website/pages/demo/DemoDocumentPage';
import { DemoRequestDocumentPage } from '../products/website/pages/demo-request/DemoRequestDocumentPage';
import { StartDocumentPage } from '../products/accounts/pages/start/StartDocumentPage';
import { ResourcesDocumentPage } from '../products/website/pages/resources/ResourcesDocumentPage';
import { InsightsDocumentPage } from '../products/website/pages/insights/InsightsDocumentPage';
import { GuidesDocumentPage } from '../products/website/pages/guides/GuidesDocumentPage';
import { CaseStudiesDocumentPage } from '../products/website/pages/case-studies/CaseStudiesDocumentPage';
import { ResearchDocumentPage } from '../products/website/pages/research/ResearchDocumentPage';
import { HelpDocumentPage } from '../products/website/pages/help/HelpDocumentPage';
import { HelpGettingStartedDocumentPage } from '../products/website/pages/help-getting-started/HelpGettingStartedDocumentPage';
import { HelpProductDocumentPage } from '../products/website/pages/help-product/HelpProductDocumentPage';
import { HelpAccountDocumentPage } from '../products/website/pages/help-account/HelpAccountDocumentPage';
import { SupportDocumentPage } from '../products/website/pages/support/SupportDocumentPage';
import { DevelopersDocumentPage } from '../products/website/pages/developers/DevelopersDocumentPage';
import { DevelopersApiDocumentPage } from '../products/website/pages/developers-api/DevelopersApiDocumentPage';
import { DevelopersSdksDocumentPage } from '../products/website/pages/developers-sdks/DevelopersSdksDocumentPage';
import { IntegrationsDocumentPage } from '../products/website/pages/integrations/IntegrationsDocumentPage';
import { DevelopersWebhooksDocumentPage } from '../products/website/pages/developers-webhooks/DevelopersWebhooksDocumentPage';
import { DevelopersChangelogDocumentPage } from '../products/website/pages/developers-changelog/DevelopersChangelogDocumentPage';
import { AboutDocumentPage } from '../products/website/pages/about/AboutDocumentPage';
import { AboutStoryDocumentPage } from '../products/website/pages/about-story/AboutStoryDocumentPage';
import { AboutLeadershipDocumentPage } from '../products/website/pages/about-leadership/AboutLeadershipDocumentPage';
import { CareersDocumentPage } from '../products/website/pages/careers/CareersDocumentPage';
import { PressDocumentPage } from '../products/website/pages/press/PressDocumentPage';
import { ContactDocumentPage } from '../products/website/pages/contact/ContactDocumentPage';
import { LegalPrivacyDocumentPage } from '../products/website/pages/legal-privacy/LegalPrivacyDocumentPage';
import { LegalTermsDocumentPage } from '../products/website/pages/legal-terms/LegalTermsDocumentPage';
import { LegalCookiesDocumentPage } from '../products/website/pages/legal-cookies/LegalCookiesDocumentPage';
import { LegalAcceptableUseDocumentPage } from '../products/website/pages/legal-acceptable-use/LegalAcceptableUseDocumentPage';
import { LegalDpaDocumentPage } from '../products/website/pages/legal-dpa/LegalDpaDocumentPage';
import { AccessibilityDocumentPage } from '../products/website/pages/accessibility/AccessibilityDocumentPage';
import { LoginDocumentPage } from '../products/accounts/pages/login/LoginDocumentPage';
import { SignupDocumentPage } from '../products/accounts/pages/signup/SignupDocumentPage';
import { ForgotPasswordDocumentPage } from '../products/accounts/pages/forgot-password/ForgotPasswordDocumentPage';
import { ResetPasswordDocumentPage } from '../products/accounts/pages/reset-password/ResetPasswordDocumentPage';
import { VerifyDocumentPage } from '../products/accounts/pages/verify/VerifyDocumentPage';
import { OnboardingDocumentPage } from '../products/accounts/pages/onboarding/OnboardingDocumentPage';
import { OsDocumentPage } from '../products/workspace/pages/os/OsDocumentPage';
import { OsTodayDocumentPage } from '../products/consistency/pages/os-today/OsTodayDocumentPage';
import { OsClarityDocumentPage } from '../products/clarity/pages/os-clarity/OsClarityDocumentPage';
import { OsCapabilityDocumentPage } from '../products/capability/pages/os-capability/OsCapabilityDocumentPage';
import { OsConsistencyDocumentPage } from '../products/consistency/pages/os-consistency/OsConsistencyDocumentPage';
import { OsProgressDocumentPage } from '../products/progress/pages/os-progress/OsProgressDocumentPage';
import { OsRhythmDocumentPage } from '../products/rhythm/pages/os-rhythm/OsRhythmDocumentPage';
import { OsCompanionDocumentPage } from '../products/companion/pages/os-companion/OsCompanionDocumentPage';
import { OsInsightsDocumentPage } from '../products/intelligence/pages/os-insights/OsInsightsDocumentPage';
import { OsBusinessDocumentPage } from '../products/business/pages/os-business/OsBusinessDocumentPage';
import { OsOpportunitiesDocumentPage } from '../products/commercial/pages/os-opportunities/OsOpportunitiesDocumentPage';
import { OsFinanceDocumentPage } from '../products/finance/pages/os-finance/OsFinanceDocumentPage';
import { OsPeopleDocumentPage } from '../products/talent/pages/os-people/OsPeopleDocumentPage';
import { OsWorkflowsDocumentPage } from '../products/workflows/pages/os-workflows/OsWorkflowsDocumentPage';
import { OsWorkflowsDetailDocumentPage } from '../products/workflows/pages/os-workflows-detail/OsWorkflowsDetailDocumentPage';
import { OsOrganizationDocumentPage } from '../products/organizations/pages/os-organization/OsOrganizationDocumentPage';
import { OsTeamsDocumentPage } from '../products/organizations/pages/os-teams/OsTeamsDocumentPage';
import { OsOrganizationRhythmDocumentPage } from '../products/organizations/pages/os-organization-rhythm/OsOrganizationRhythmDocumentPage';
import { OsAnalyticsDocumentPage } from '../products/analytics/pages/os-analytics/OsAnalyticsDocumentPage';
import { OsIntegrationsDocumentPage } from '../products/integrations/pages/os-integrations/OsIntegrationsDocumentPage';
import { OsGovernanceDocumentPage } from '../products/governance/pages/os-governance/OsGovernanceDocumentPage';
import { OsAuditDocumentPage } from '../products/governance/pages/os-audit/OsAuditDocumentPage';
import { OsAdminDocumentPage } from '../products/organizations/pages/os-admin/OsAdminDocumentPage';
import { OsProfileDocumentPage } from '../products/accounts/pages/os-profile/OsProfileDocumentPage';
import { OsSettingsDocumentPage } from '../products/settings/pages/os-settings/OsSettingsDocumentPage';
import { OsSettingsAiDocumentPage } from '../products/settings/pages/os-settings-ai/OsSettingsAiDocumentPage';
import { OsSettingsPrivacyDocumentPage } from '../products/settings/pages/os-settings-privacy/OsSettingsPrivacyDocumentPage';
import { OsNotificationsDocumentPage } from '../products/notifications/pages/os-notifications/OsNotificationsDocumentPage';
import { OsSettingsWorkspaceDocumentPage } from '../products/settings/pages/os-settings-workspace/OsSettingsWorkspaceDocumentPage';
import { OsSettingsMembersDocumentPage } from '../products/settings/pages/os-settings-members/OsSettingsMembersDocumentPage';
import { OsSettingsBillingDocumentPage } from '../products/settings/pages/os-settings-billing/OsSettingsBillingDocumentPage';
import { OsSettingsPlanDocumentPage } from '../products/settings/pages/os-settings-plan/OsSettingsPlanDocumentPage';
export const documentPages: Record<string, ComponentType<DocumentPageProps>> = {
"/": HomeDocumentPage,
"/product": ProductDocumentPage,
"/product/companion": ProductCompanionDocumentPage,
"/product/experience": ProductExperienceDocumentPage,
"/product/intelligence": ProductIntelligenceDocumentPage,
"/product/workflows": ProductWorkflowsDocumentPage,
"/product/organizations": ProductOrganizationsDocumentPage,
"/how-it-works": HowItWorksDocumentPage,
"/how-it-works/clarity": HowItWorksClarityDocumentPage,
"/how-it-works/capability": HowItWorksCapabilityDocumentPage,
"/how-it-works/consistency": HowItWorksConsistencyDocumentPage,
"/how-it-works/growth": HowItWorksGrowthDocumentPage,
"/how-it-works/rhythm": HowItWorksRhythmDocumentPage,
"/who-its-for": WhoItsForDocumentPage,
"/who-its-for/individuals": WhoItsForIndividualsDocumentPage,
"/who-its-for/professionals": WhoItsForProfessionalsDocumentPage,
"/who-its-for/creators": WhoItsForCreatorsDocumentPage,
"/who-its-for/founders": WhoItsForFoundersDocumentPage,
"/who-its-for/teams": WhoItsForTeamsDocumentPage,
"/who-its-for/smes": WhoItsForSmesDocumentPage,
"/who-its-for/enterprises": WhoItsForEnterprisesDocumentPage,
"/who-its-for/institutions": WhoItsForInstitutionsDocumentPage,
"/enterprise": EnterpriseDocumentPage,
"/security": SecurityDocumentPage,
"/responsible-ai": ResponsibleAiDocumentPage,
"/trust/privacy": TrustPrivacyDocumentPage,
"/trust/governance": TrustGovernanceDocumentPage,
"/pricing": PricingDocumentPage,
"/experts": ExpertsDocumentPage,
"/enterprise/contact": EnterpriseContactDocumentPage,
"/demo": DemoDocumentPage,
"/demo/request": DemoRequestDocumentPage,
"/start": StartDocumentPage,
"/resources": ResourcesDocumentPage,
"/insights": InsightsDocumentPage,
"/guides": GuidesDocumentPage,
"/case-studies": CaseStudiesDocumentPage,
"/research": ResearchDocumentPage,
"/help": HelpDocumentPage,
"/help/getting-started": HelpGettingStartedDocumentPage,
"/help/product": HelpProductDocumentPage,
"/help/account": HelpAccountDocumentPage,
"/support": SupportDocumentPage,
"/developers": DevelopersDocumentPage,
"/developers/api": DevelopersApiDocumentPage,
"/developers/sdks": DevelopersSdksDocumentPage,
"/integrations": IntegrationsDocumentPage,
"/developers/webhooks": DevelopersWebhooksDocumentPage,
"/developers/changelog": DevelopersChangelogDocumentPage,
"/about": AboutDocumentPage,
"/about/story": AboutStoryDocumentPage,
"/about/leadership": AboutLeadershipDocumentPage,
"/careers": CareersDocumentPage,
"/press": PressDocumentPage,
"/contact": ContactDocumentPage,
"/legal/privacy": LegalPrivacyDocumentPage,
"/legal/terms": LegalTermsDocumentPage,
"/legal/cookies": LegalCookiesDocumentPage,
"/legal/acceptable-use": LegalAcceptableUseDocumentPage,
"/legal/dpa": LegalDpaDocumentPage,
"/accessibility": AccessibilityDocumentPage,
"/login": LoginDocumentPage,
"/signup": SignupDocumentPage,
"/forgot-password": ForgotPasswordDocumentPage,
"/reset-password": ResetPasswordDocumentPage,
"/verify": VerifyDocumentPage,
"/onboarding": OnboardingDocumentPage,
"/os": OsDocumentPage,
"/os/today": OsTodayDocumentPage,
"/os/clarity": OsClarityDocumentPage,
"/os/capability": OsCapabilityDocumentPage,
"/os/consistency": OsConsistencyDocumentPage,
"/os/progress": OsProgressDocumentPage,
"/os/rhythm": OsRhythmDocumentPage,
"/os/companion": OsCompanionDocumentPage,
"/os/insights": OsInsightsDocumentPage,
"/os/business": OsBusinessDocumentPage,
"/os/opportunities": OsOpportunitiesDocumentPage,
"/os/finance": OsFinanceDocumentPage,
"/os/people": OsPeopleDocumentPage,
"/os/workflows": OsWorkflowsDocumentPage,
"/os/workflows/[id]": OsWorkflowsDetailDocumentPage,
"/os/organization": OsOrganizationDocumentPage,
"/os/teams": OsTeamsDocumentPage,
"/os/organization/rhythm": OsOrganizationRhythmDocumentPage,
"/os/analytics": OsAnalyticsDocumentPage,
"/os/integrations": OsIntegrationsDocumentPage,
"/os/governance": OsGovernanceDocumentPage,
"/os/audit": OsAuditDocumentPage,
"/os/admin": OsAdminDocumentPage,
"/os/profile": OsProfileDocumentPage,
"/os/settings": OsSettingsDocumentPage,
"/os/settings/ai": OsSettingsAiDocumentPage,
"/os/settings/privacy": OsSettingsPrivacyDocumentPage,
"/os/notifications": OsNotificationsDocumentPage,
"/os/settings/workspace": OsSettingsWorkspaceDocumentPage,
"/os/settings/members": OsSettingsMembersDocumentPage,
"/os/settings/billing": OsSettingsBillingDocumentPage,
"/os/settings/plan": OsSettingsPlanDocumentPage
};
